import React, { useState, useRef, useEffect } from "react";
import { Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import styled from "styled-components";
import LabelList from "./LabelList";
import MembersList from "./MembersList";
import PriorityList from "./PriorityList";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import { useDispatch } from "react-redux";
import { updateProject } from "actions/project/updateProject";
import { useTranslation } from "react-i18next";

const LeftPart = ({
  projectInfo = {},
  status = {},
  handleOpenModal = () => {},
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { membersAdded } = useSelector(
    ({ project }) => project.memberProject.data
  );
  const _handleAddMember = () => {
    handleOpenModal("ADD_MEMBER");
  };

  const dataMembers = membersAdded.length
    ? membersAdded
    : projectInfo?.members || [];

  const _handleUpdateField = (type, value) => {
    const payload = {
      projectId: projectInfo?.id,
      name: projectInfo?.name,
      description: projectInfo?.description,
      projectGroupId: projectInfo?.group_project_id,
      priority: projectInfo?.priority_code,
      // currency: projectInfo?.currency,
      // work_type: projectInfo?.work_type
      [type]: value,
    };
    dispatch(updateProject(payload));
  };

  return (
    <WrapperLeftPart>
      <Typography variant="p" component="div">
        {t("PROJECT_PAGE.CREATE_BY", {
          name: projectInfo?.user_create?.name,
          time: projectInfo?.date_start,
        })}
      </Typography>

      <WrapperInformation
        title={t("PROJECT_PAGE.NAME_PROJECT")}
        description={projectInfo.name}
        styleDescription={{
          fontSize: "17px",
          fontWeight: 500,
          color: "#1e1f21",
        }}
        canEdit
        onSubmit={_handleUpdateField}
        type="name"
      />

      <WrapperInformation
        title={t("PROJECT_PAGE.DESCRIPTION")}
        description={projectInfo.description}
        canEdit
        onSubmit={_handleUpdateField}
        type="description"
      />

      <WrapperInformation title={t("PROJECT_PAGE.LABELS")} component="div">
        <LabelList project={projectInfo} />
      </WrapperInformation>

      <WrapperInformation title={t("PROJECT_PAGE.MEMBERS")} component="div">
        <MembersList
          project={projectInfo}
          data={dataMembers || []}
          onAddMember={_handleAddMember}
        />
      </WrapperInformation>

      <WrapperInformation title={t("PROJECT_PAGE.PRIORITY")} component="div">
        <PriorityList
          projectId={projectInfo?.id || null}
          defaultPriority={projectInfo.priority_code}
        />
      </WrapperInformation>

      <WrapperInformation title={t("PROJECT_PAGE.PROCESS")} component="div">
        <Typography variant="p" style={{ color: "black", fontWeight: 500 }}>
          {projectInfo?.duration} ngày
        </Typography>
        <p style={{ fontWeight: 500 }}>
          {t("PROJECT_PAGE.START")} {projectInfo?.date_start}
        </p>
        <Typography variant="p" style={{ fontWeight: 500 }}>
          {t("PROJECT_PAGE.FINISH")} {projectInfo?.date_end}
        </Typography>
      </WrapperInformation>

      <WrapperInformation
        title={t("PROJECT_PAGE.SETTING.TITLE")}
        style={{ color: "black", fontWeight: "400" }}
      >
        <WrapperSetting>
          <p>
            {t("PROJECT_PAGE.SETTING.COPY.TITLE")}:{" "}
            {status.copy
              ? t("PROJECT_PAGE.SETTING.COPY.YES")
              : t("PROJECT_PAGE.SETTING.COPY.NO")}
          </p>
          <span onClick={() => handleOpenModal("SETTING")}>
            {t("PROJECT_PAGE.SETTING.CHANGE")}
          </span>
        </WrapperSetting>
        <WrapperSetting>
          <p>
            {t("PROJECT_PAGE.SETTING.NOTI.TITLE")}:{" "}
            {status.notification
              ? t("PROJECT_PAGE.SETTING.NOTI.YES")
              : t("PROJECT_PAGE.SETTING.NOTI.NO")}
          </p>
          <span onClick={() => handleOpenModal("SETTING")}>
            {t("PROJECT_PAGE.SETTING.CHANGE")}
          </span>
        </WrapperSetting>
        <WrapperSetting>
          <span onClick={() => handleOpenModal("SETTING")}>
            {t("PROJECT_PAGE.SETTING.ALL")}
          </span>
        </WrapperSetting>
      </WrapperInformation>
    </WrapperLeftPart>
  );
};

const WrapperInformation = ({
  title,
  children,
  style = {},
  description = null,
  styleDescription = {},
  canEdit = false,
  onSubmit = () => {},
  type,
}) => {
  const refInput = useRef(null);
  const [value, setValue] = useState(description);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (description) {
      setValue(description);
      refInput.current = description;
    }
  }, [description]);

  const _handleKeyDown = (e) => {
    if (e.which === 13 && !e.shiftKey) {
      setIsEditing(false);
      onSubmit(type, value);
    }
  };

  const _handleBlur = (e) => {
    setIsEditing(false);
    if (value !== description) {
      onSubmit(type, value);
    }
  };

  const _handleChange = (e) => {
    setValue(e.target.value);
  };

  const _handleEdit = () => {
    setIsEditing(true);
    setTimeout(() => {
      refInput.current.focus();
    }, 100);
  };

  return (
    <div style={{ marginBottom: "20px", ...style }}>
      <StyledLabel variant="h5" component="div">
        {title}
        {canEdit && (
          <IconButtonStyles onClick={_handleEdit}>
            <EditIcon />
          </IconButtonStyles>
        )}
      </StyledLabel>

      {canEdit &&
        isEditing &&
        (type === "description" ? (
          <TextAreaCustom
            ref={refInput}
            value={value}
            name={description}
            // type="text"
            placeholder=""
            // onBlur={_handleBlur}
            onKeyDown={_handleKeyDown}
            onChange={_handleChange}
            style={{
              ...styleDescription,
            }}
            rows={5}
          />
        ) : (
          <InputStyled
            ref={refInput}
            value={value}
            name={description}
            type="text"
            placeholder=""
            onBlur={_handleBlur}
            onKeyDown={_handleKeyDown}
            onChange={_handleChange}
            style={{
              ...styleDescription,
            }}
          />
        ))}

      {!isEditing && description ? (
        <Typography
          variant="p"
          component="div"
          style={{
            fontSize: "14px",
            lineHeight: "22px",
            color: "#1e1f21",
            ...styleDescription,
          }}
        >
          {description}
        </Typography>
      ) : (
        children
      )}
    </div>
  );
};

const WrapperSetting = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
  justify-content: space-between;
  margin: 10px 0;
  p {
    margin: 0;
  }
  > span {
    color: #4284f3ff;
    font-weight: 500;
    cursor: pointer;
  }
`;
const WrapperLeftPart = styled.div`
  // padding: 20px;
  // min-height: 100vh;
  height: 100%;
  color: #878787;
  background: white;
`;
const StyledLabel = styled(Typography)`
  font-size: 20px;
  line-height: 28px;
  margin-bottom: 4px;
  margin-top: 24px;
  width: 280px;
  color: #878787;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Helvetica, Arial, sans-serif;

  &:hover {
    & > button {
      visibility: visible !important;
    }
  }
`;

const InputStyled = styled.input`
  fontsize: 14px;
  lineheight: 22px;
  color: #1e1f21;
  width: 100%;
  margin-left: -5px;
  outline: none;
  border: 0px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Helvetica, Arial, sans-serif;
`;

const IconButtonStyles = styled(IconButton)`
  visibility: hidden;
  margin-top: -5px;
  background: #ededed !important;
  border-radius: 6px !important;
  margin-left: 10px !important;
  padding: 5px !important;
`;

export const TextAreaCustom = styled.textarea`
  border-radius: 4px;
  outline: none;
  padding: 18.5px 14px;
  font-size: 14px;
  line-height: 1.5;
  width: 95%;
  min-width: 95%;
  color: rgb(0, 118, 243);
  border: 1px solid rgb(0 0 0 / 23%);
  &:hover,
  &focus {
    border: 1px solid rgb(0, 118, 243);
    box-shadow: 0px 0px 10px #d5d5d5;
  }
`;

export default LeftPart;
